export default {"src":"/_next/static/media/Cross-icon.c337d1ba.svg","height":25,"width":25};